import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as FieldComponents from "@Shared/components/sections/index";
import { GenericModal } from "@Shared/components/modals";
import { mapState, mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
import { SAVE_APPLICATION_FEES } from "../../../../store/lender-submit-actions";
export default defineComponent({
  name: "CalculatedDetails",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    GenericModal
  }),
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingApr: false,
      overrideAprChecked: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationStore", ["feesCalculatedDetails", "currentFeesMortgageType"])), {}, {
    currentCalculatedDetails() {
      return this.feesCalculatedDetails[this.currentFeesMortgageType];
    },
    isAprDisabled() {
      return !this.overrideAprChecked;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SAVE_APPLICATION_FEES])), {}, {
    handleCheckboxChange(value) {
      this.overrideAprChecked = value;
      if (value) {
        this.$bvModal.show("override-modal");
      }
      this.updateAndSaveApr({
        overrideApr: value
      });
    },
    handleAprChange(value) {
      this.updateAndSaveApr({
        overrideApr: true,
        newAprValue: _parseFloat(value)
      });
    },
    async updateAndSaveApr({
      overrideApr,
      newAprValue
    }) {
      this.loadingApr = true;
      await this.SAVE_APPLICATION_FEES({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        changeApr: {
          overrideApr,
          newAprValue: newAprValue ? newAprValue : this.currentCalculatedDetails.apr,
          mortgageIndex: this.currentFeesMortgageType
        }
      });
      this.loadingApr = false;
    },
    closeModal() {
      this.$bvModal.hide("override-modal");
    }
  })
});